<div class="order-details-card-view">
  <div class="card-container">
    <div class="header">
      <strong>{{ headerName }}</strong>
    </div>
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
</div>